import { render } from "./Closures.vue?vue&type=template&id=73d4a512&scoped=true"
import script from "./Closures.vue?vue&type=script&lang=js"
export * from "./Closures.vue?vue&type=script&lang=js"

import "./Closures.vue?vue&type=style&index=0&id=73d4a512&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73d4a512"

export default script